var Reflux = require('reflux');

module.exports = Reflux.createStore({
    
  mqSM: window.matchMedia( "(min-width: 768px)" ),
  mqMD: window.matchMedia( "(min-width: 992px)" ),

  init: function() {
 
    if (matchMedia && this.mqMD.addListener) {
      this.mqSM.addListener(this.screenWidthCrossSM);
      this.mqMD.addListener(this.screenWidthCrossMD);
    }
    if (!this.mqSM.matches) {
      this.width = "SM";
    } else if (!this.mqMD.matches) {
      this.width = "MD";
    } else {
      this.width = "LG";
    }
    this.trigger('change', this.width);
  },

  screenWidthCrossSM: function(mq) {
    if (!mq.matches) {
      this.width = "SM";
    } else {
      this.width = "MD";
    }
    this.trigger('change', this.width);
  },

  screenWidthCrossMD: function(mq) {
    if (!mq.matches) {
      this.width = "MD";
    } else {
      this.width = "LG";
    }
    this.trigger('change', this.width);
  }
});